<template>
  <div id="app">
    <notifications group="app" />
  </div>
</template>